import React, { useState, useEffect, useRef } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardElement,
  useStripe,
  useElements,
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
} from "@stripe/react-stripe-js";
import { Modal } from "react-bootstrap";
import { addCardFunc, getStripeCards, setOpenCartPage } from "../../actions/stripe";
import { Controller, useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { stripeSecertKey } from "../../constants";

const stripePromise = loadStripe(stripeSecertKey);

const CheckoutForm = ({ setOpenAddCard }) => {
  const {
    control,
    formState: { errors },
    getValues,
    reset,
  } = useForm();
  const dispatch = useDispatch();

  const stripe = useStripe();
  const elements = useElements();
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  const handleSaveCard = async (e) => {
    e.preventDefault();
    setMessage('');
    setLoading(true);

    if (!stripe || !elements || !getValues('name')) {
      setMessage('Error, please complete the card details.');
      setLoading(false);
      return;
    }

    try {
      const response = await addCardFunc();
      const { clientSecret } = response;
      if (!clientSecret) {
        setMessage("Error creating setup intent.");
        setLoading(false);
        return;
      }
      const { setupIntent, error } = await stripe.confirmCardSetup(
        clientSecret,
        {
          payment_method: {
            card: elements.getElement(CardElement),
            billing_details: { name: getValues('name') || '' },
          },
        }
      );
      if (error) {
        setMessage(`Error: ${error.message}`);
        setLoading(false);
      } else {
        setMessage('Card saved successfully!');
        dispatch(getStripeCards(true));
        setOpenAddCard();
        dispatch(setOpenCartPage(true))
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      setMessage("Something went wrong.");
    } finally {
      setLoading(false);
    }
  };




  const checkboxRef = useRef(null);

  const handleToggle = () => {
    if (checkboxRef.current) {
      checkboxRef.current.checked = !checkboxRef.current.checked;
    }
  };

  return (
    <>
      <div className="row">
        <div className="col-md-12 cardHeaderSection">
          <h3 className="m-0">Add New Card</h3>
          <p className="m-0 cursor-pointer" onClick={setOpenAddCard}>Close</p>
        </div>
        <div className="col-md-12 cardInputFieldSection">
          <CardElement className="cardInputField" />
        </div>
        <div className="col-md-12 cardInputFieldSection">
          <Controller
            control={control}
            render={({ field }) => (
              <input
                type="text"
                placeholder="Name on card"
                className="cardInputField"
                {...field}
              />
            )}
            name="name"
            rules={{
              required: { value: true, message: 'Name is required' },
            }}
          />
          {errors && errors.name && (
            <span className="errorMessage">{errors?.name?.message}</span>
          )}
        </div>

        {/* <div className="col-md-12">
            <div className="cardInputFieldSection">
              <div className="inforCardSection">
                <p className="m-0">Nickname for card</p>
                <img src="assets/img/InfoIconblack.svg" alt="" />
              </div>
              <div className="nickNameSelectedAlign">
                <div className="nickNameselected">
                  <p className="m-0">Personal</p>
                </div>
                <div className="nickNameselected">
                  <p className="m-0">Business</p>
                </div>
                <div className="nickNameselected">
                  <p className="m-0">Other</p>
                </div>
              </div>
            </div>

            <div className="secureCard">
              <input
                type="checkbox"
                className="customCheckbox"
                ref={checkboxRef}
              />
              <p className="m-0" onClick={handleToggle}>
                Secure this card. <span>Why is it important?</span>
              </p>
            </div>
          </div> */}

        <div className="col-md-12">
          <button
            onClick={handleSaveCard}
            className="gobackButton continueButton continueSection"
            disabled={!stripe || !elements || loading}
          >
            {loading && (
              <i className="animateSpin fa-solid fa-circle-notch"></i>
            )}{" "}
            Continue
          </button>
          {message && <span className="errorMessage">{message}</span>}
        </div>
      </div>
    </>
  );
};

export default function AddNewCard({ isOpen, setOpenAddCard }) {
  return (
    <>
      <Modal
        className="custom-modal"
        show={isOpen}
        onHide={setOpenAddCard}
      >
        <Elements stripe={stripePromise} >
          <CheckoutForm setOpenAddCard={setOpenAddCard} />
        </Elements>
      </Modal>
    </>
  );
}
